import { IconeAlerta, IconeCheque } from '../../../components/Icones'

/**
 * O que falta no plano, dito ANTES de a pessoa tentar enviar.
 *
 * A API devolve `pendencias` em todo detalhe justamente para isto: o comentário do backend que
 * monta o campo diz que é "para a tela mostrar 'faltam 2 itens' antes de a pessoa clicar em
 * enviar". Sem isso, o fluxo é preencher o que se lembra, clicar, levar a recusa e recomeçar —
 * que é como o sistema anterior ensinava a desistir e voltar para a planilha.
 *
 * O texto de cada pendência vem do domínio e NÃO é reescrito aqui. É de propósito: a mesma frase
 * aparece em três lugares — nesta lista, no impedimento do botão "Enviar ao comitê"
 * (`Gmud.acoesDisponiveis` prefixa com "Falta preencher: ") e no 422 de quem tentar mesmo assim.
 * Traduzir num deles faria o usuário achar que são exigências diferentes.
 *
 * Lista vazia NÃO quer dizer "pode enviar": `pendencias` cobre só o plano (são os seis artefatos
 * obrigatórios de `PlanoDeMudanca.pendencias()`), enquanto a invariante de envio também cobra o
 * número do chamado. Por isso o texto do caso completo fala do plano e manda ler o botão, em vez
 * de prometer um envio que o servidor ainda pode recusar.
 *
 * @param props o que o servidor listou como faltando no plano
 * @returns o resumo de pendências
 */
export function ResumoDePendencias({ pendencias }: { pendencias: string[] }) {
  if (pendencias.length === 0) {
    return (
      <p className="flex gap-2.5 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-900">
        <IconeCheque className="mt-0.5 h-4 w-4 shrink-0 text-green-700" />
        <span className="max-w-prose">
          <strong className="font-semibold">Os itens obrigatórios do plano estão preenchidos.</strong> Se ainda faltar
          alguma coisa para enviar ao comitê — o número do chamado, por exemplo —, o botão de envio diz o que é.
        </span>
      </p>
    )
  }

  const total = pendencias.length

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <p className="flex gap-2.5 font-semibold">
        <IconeAlerta className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />
        {total === 1 ? 'Falta 1 item para o plano ficar completo' : `Faltam ${total} itens para o plano ficar completo`}
      </p>
      <ul className="mt-2 list-inside list-disc space-y-1 pl-6">
        {pendencias.map((pendencia) => (
          <li key={pendencia}>{pendencia}</li>
        ))}
      </ul>
      <p className="mt-2 max-w-prose pl-6 text-xs">
        Enquanto faltar, a ação de enviar ao comitê fica desabilitada e repete esta mesma lista.
      </p>
    </div>
  )
}
